
<div class="fv-row" [formGroup]="form" dir="rtl">
  <div class="row">
    <div class="col-lg-6">
      <input formControlName="payment_method" name="payment_method" type="radio" class="btn-check"
        id="kt_create_account_form_account_type_personal" [value]="1" />
      <label class="
          btn btn-outline btn-outline-dashed btn-outline-default
          p-7
          d-flex
          align-items-center
          mb-10  flex justify-between
        " for="kt_create_account_form_account_type_personal">
        <span class="d-block fw-bold text-start ml-2">
          <span class="text-dark fw-bolder d-block fs-4 mb-2">الدفع عند الوصول</span>
          <!-- <span class="text-gray-400 fw-bold fs-6">
            يعني يوم توصل الملعب أدفع هناك ع الراحات
          </span> -->
        </span>
        <span class="svg-icon svg-icon-3x me-5">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1"
            stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z" />
          </svg>
        </span>
      </label>
    </div>
    <div class="col-lg-6">
      <input formControlName="payment_method" name="payment_method" type="radio" class="btn-check"
        id="kt_create_account_form_account_type_corporate" [value]="2" />
      <label class="
          btn btn-outline btn-outline-dashed btn-outline-default
          p-7
          d-flex
          align-items-center flex justify-between" for="kt_create_account_form_account_type_corporate">
        <span class="d-block fw-bold text-start ml-2">
          <span class="text-dark fw-bolder d-block fs-4 mb-2">الدفع أونلاين</span>
          <!-- <span class="text-gray-400 fw-bold fs-6">
            يعني تدفع عن طريق ثواني بادخال البيانات وكذا
          </span> -->
        </span>
        <span class="svg-icon svg-icon-3x me-5">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1"
            stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
          </svg>
        </span>
      </label>
    </div>
  </div>
</div>
